import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { loadContent } from "@/content/loader";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Support from "@/pages/Support";
import Walk from "@/pages/Walk";
import GetInvolved from "@/pages/GetInvolved";
import News from "@/pages/News";
import Photos from "@/pages/Photos";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Accessibility from "@/pages/Accessibility";
import AdminApp from "@/admin/AdminApp";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let live = true;
    loadContent().finally(() => live && setReady(true));
    return () => {
      live = false;
    };
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <p role="status" className="font-serif text-xl italic text-sage">
          Loading TJ's Light…
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminApp />} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/support" element={<Support />} />
          <Route path="/walking-for-hope" element={<Walk />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/news" element={<News />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
      <Toaster position="bottom-center" richColors={false} />
    </BrowserRouter>
  );
}

export default App;
